import { render, staticRenderFns } from "./outlandManage.vue?vue&type=template&id=c6920832&scoped=true"
import script from "./outlandManage.vue?vue&type=script&lang=js"
export * from "./outlandManage.vue?vue&type=script&lang=js"
import style0 from "./outlandManage.vue?vue&type=style&index=0&id=c6920832&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6920832",
  null
  
)

export default component.exports